import { PaymentCodes , PaymentMethod } from './types'

// Which gateway serves online transfers is switched on the backend, so the redirect
// methods are identified by exclusion rather than by listing every operator.
const selfServedPaymentCodes: string[] = [
  PaymentCodes.BLIK,
  PaymentCodes.BLIK_ONE_CLICK,
  PaymentCodes.ON_DELIVERY
]

export const isOnlineTransferMethod = (
  paymentMethod: Pick<PaymentMethod, 'code'>
): boolean => !selfServedPaymentCodes.includes(paymentMethod.code)

export const redirectToPaymentLink = (paymentLink: string) => {
  window.location.assign(paymentLink)
}

export const catchExistingPayment = (errorMessage: string, cb: () => void) => {
  if (errorMessage === 'Zamówienie zostało opłacone poprawnie.') {
    setTimeout(() => cb(), 1500)
  }
}
